import * as React from 'react';
/**
 * TODO consider getting rid from wrapper variant
 * @ignore - internal component.
 */

export var WrapperVariantContext =
/*#__PURE__*/
React.createContext(null);